/* global crypto */

import { useEffect } from 'react';
import LogRocket from 'logrocket';
import config from '~/Config';
import { ConsentApi } from '~/Providers/Api';
import { CONSENT_TYPE_COOKIES } from '~/Components/Global/ConsentRequiredView';

export const guid = () => {
  var buf = new Uint16Array(8);
  window.crypto.getRandomValues(buf);
  function s4(num) {
    var ret = num.toString(16);
    while (ret.length < 4) {
      ret = '0' + ret;
    }
    return ret;
  }
  return (
    s4(buf[0]) +
    s4(buf[1]) +
    '-' +
    s4(buf[2]) +
    '-' +
    s4(buf[3]) +
    '-' +
    s4(buf[4]) +
    '-' +
    s4(buf[5]) +
    s4(buf[6]) +
    s4(buf[7])
  );
};

export const useMountEffect = func => useEffect(func, []);

export const useResizeEffect = func => {
  useMountEffect(() => {
    window.addEventListener('resize', func);
    return () => window.removeEventListener('resize', func);
  });
};

export const initLogrocket = async (userId, force = false) => {
  if (
    config.logrocket.enabled &&
    (force || config.logrocket.userIds.filter(id => id === userId).length)
  ) {
    console.log('initLogrocket', userId, force);
    try {
      const consentSettings = await ConsentApi.settings();
      if (consentSettings[CONSENT_TYPE_COOKIES]) {
        console.log('Not starting logrocket as tracking consent is required');
        if (window.Rollbar) window.Rollbar.error('Logrocket: Tracking consent is required');
        return;
      }
    } catch (error) {
      console.error('initLogrocket', 'Error getting consent settings', error);
      if (window.Rollbar) window.Rollbar.error('Logrocket: Error getting consent settings', error);
      return;
    }

    console.log('initLogrocket', 'initializing');
    LogRocket.init(config.logrocket.key, {
      release: `${VERSION}-${COMMIT}-${BUILD_NUMBER}`,
    });
    LogRocket.identify(userId);
    console.log('initLogrocket', 'initialized!');
    if (window.Rollbar) window.Rollbar.info('Logrocket: Initialized');
  }
};

// Hash functions for Facebook pixel parameters
export async function hashEmail(email) {
  try {
    if (!email || typeof email !== 'string') {
      console.warn('Invalid email provided for hashing');
      return null;
    }

    if (!window.crypto?.subtle) {
      console.warn('crypto.subtle not available');
      return null;
    }

    const normalized = email.trim().toLowerCase();
    const encoder = new TextEncoder();
    const data = encoder.encode(normalized);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  } catch (error) {
    console.error('Failed to hash email:', error);
    return null;
  }
}

export { default as useLeanplumVariable } from './useLeanplumVariable';
export { default as usePaddleCheckout } from './usePaddleCheckout';
export { default as usePaddle } from './usePaddle';
export * from './awcTracking';
export * from './facebookPixelTracking';
